import { _get } from '@/common/request';
export default {
    state: {
        applications: [],
    },
    actions: {
        // 动态更新第三方应用列表信息
        $_UpdateAppInfo: function (_a) {
            var commit = _a.commit;
            return new Promise(function (resolve, reject) {
                // https://yapi.lanhanba.com/project/47/interface/api/24416
                _get('/property/services/overview', null, true).then(function (_a) {
                    var data = _a.data;
                    commit('SET_APPS', data);
                    resolve(data);
                }, function (err) {
                    reject(err);
                });
            });
        },
    },
    mutations: {
        // 设置应用列表
        SET_APPS: function (state, data) {
            if (data.length && data.length > 0) {
                state.applications = data;
            }
            else {
                state.applications = [];
            }
        },
    },
    getters: {},
};
